import React, { useState } from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import LABEL from '../../../business-const/Label/Label'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import AuthService from '../../../business-api/AuthService'

import {
    comparaArraysJSON
} from '../../../business-components/Array/Array'

import DragDropTwoList from '../../../business-components/DragDrop/DragDropTwoList'

import {
    GridContainer,
    GridItem4sm6xs6,
    GridItem4sm12xs12,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivEntradaDados,
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    TextValidatorTextRequired,
} from '../../../business-components/TextValidator/TextValidator'

//import {
//    PaisagemRetratoRadioGroupRequired
//} from '../../../business-rules/RadioGroup/PaisagemRetratoRadioGroup'

import {
    ButtonPadraoSubmit,
    ButtonIncluirTemplate,
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import {
    atualizarCenario,
} from './EstudoServiceCenarios'

import {
    reiniciaConfiguracaoRelatorioReportList,
    inicializaConfiguracaoRelatorio,
    incluirTemplate,
} from './EstudoServiceConfiguracaoRelatorio'

import {
    Template
} from './EstudoCompConfiguracao'



const EstudoFormConfiguracaoRelatorio = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, linhaTipoLicenca,
    jsonPagina, jsonUsuario, jsonUsuarioAdmin }) => {

    const [templateList, setTemplateList] = useState(null)

    useSingleton(() => {

        inicializaConfiguracaoRelatorio(variaveisGlobais, values, values.idFormList, linhaTipoLicenca, jsonPagina,
            jsonUsuario, jsonUsuarioAdmin, setTemplateList)
    })



    return (
        templateList
            ?
                <ValidatorForm 
                    onSubmit={handleSubmit}
                    onError={
                        () => null
                    }
                >
                    <GridContainer>
                        <GridItem12>
                            <CardGridEntradaDados>
                                <CardGridDivHeaderEntradaDados>
                                    <CardGridDivEntradaDados>
                                        <GridContainer>
                                            <GridItem4sm12xs12
                                                className="mt-2"
                                            >
                                                {LABEL.configuracaoRelatorioTitulo}
                                            </GridItem4sm12xs12>

                                            <GridItem4sm6xs6>
                                                <GridContainer>
                                                    <GridItem12>
                                                        <Template
                                                            values={values}
                                                            handleChange={handleChange}
                                                            templateList={templateList}
                                                            linhaTipoLicenca={linhaTipoLicenca}
                                                            jsonPagina={jsonPagina}
                                                        />
                                                    </GridItem12>

                                                    {/*
                                                    <GridItem12>
                                                        <PaisagemRetratoRadioGroupRequired
                                                            name={"disposicaoRelatorio"}
                                                            value={values.disposicaoRelatorio || ''}
                                                            onChange={handleChange}
                                                        />
                                                    </GridItem12>
                                                    */}
                                                </GridContainer>
                                            </GridItem4sm6xs6>

                                            <GridItem4sm6xs6>
                                                {!comparaArraysJSON(values.reportImprimir,
                                                pesquisaList(templateList, values.template).relatorio.reportImprimir) && (
                                                    <>
                                                        <CustomizedDialogsPopup
                                                            maxWidth='sm'
                                                            popupTitle={LABEL.buttonIncluirTemplate}
                                                            PopupButton={ButtonIncluirTemplate}
                                                            popupComponent={
                                                                <TextValidatorTextRequired
                                                                    name={"descricaoTemplate"}
                                                                    label={LABEL.template}
                                                                    value={values.descricaoTemplate || ''}
                                                                    onChange={handleChange}
                                                                    tamMax={TAMMAX.descricaoTemplate}
                                                                    notToUpperCase={true}
                                                                />
                                                            }
                                                            open={() => {
                                                                setFieldValue('descricaoTemplate', '')
                                                            }}
                                                            PopupButtonAction={ButtonIncluirTemplate}
                                                            popupButtonActionCondition={values.descricaoTemplate}
                                                            popupButtonActionOnclick={() => {
                                                                incluirTemplate(variaveisGlobais,
                                                                    values, jsonUsuario)

                                                                inicializaConfiguracaoRelatorio(
                                                                    variaveisGlobais, values, values.idFormList,
                                                                    linhaTipoLicenca, jsonPagina,
                                                                    jsonUsuario, jsonUsuarioAdmin,
                                                                    setTemplateList)

                                                                setFieldValue('template',
                                                                    AuthService.obterUsuarioLogado(variaveisGlobais) +
                                                                        '-' + jsonUsuario.contConfiguracaoRelatorio)
                                                            }}
                                                        />
                                                    
                                                        <ButtonPadraoSubmit
                                                            className="mt-2 ml-2"
                                                            label={LABEL.buttonReobterTemplate}
                                                            onClick={() => {
                                                                reiniciaConfiguracaoRelatorioReportList(values,
                                                                    templateList, linhaTipoLicenca, jsonPagina)
                                                                atualizarCenario(values)
                                                                setFieldValue(
                                                                    `values.reportImprimir`,
                                                                    values.reportImprimir,
                                                                )
                                                            }}
                                                        />
                                                    </>
                                                )}
                                            </GridItem4sm6xs6>
                                        </GridContainer>
                                    </CardGridDivEntradaDados>
                                </CardGridDivHeaderEntradaDados>

                                <CardGridDivBody>
                                    <GridContainer>
                                        <GridItem12>
                                            <DragDropTwoList
                                                label1={LABEL.imprimir}
                                                name1={"reportImprimir"}
                                                list1={values.reportImprimir}
                                                label2={LABEL.naoImprimir}
                                                name2={"reportNaoImprimir"}
                                                list2={values.reportNaoImprimir}
                                                handleChange={handleChange}
                                            />
                                        </GridItem12>
                                    </GridContainer>
                                </CardGridDivBody>
                            </CardGridEntradaDados>
                        </GridItem12>
                    </GridContainer>
                </ValidatorForm>
            :
                ''
    )
}

export default EstudoFormConfiguracaoRelatorio